import { render, staticRenderFns } from "./EditHub.vue?vue&type=template&id=631ae8c4"
import script from "./EditHub.vue?vue&type=script&lang=js"
export * from "./EditHub.vue?vue&type=script&lang=js"
import style0 from "./EditHub.vue?vue&type=style&index=0&id=631ae8c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports